module.exports = __webpack_public_path__ + "img/network.15453d9d.svg";